export function arrayRemoveOne<T>(array: T[], target: T) {
	const index = array.indexOf(target);
	if (index !== -1) {
		array.splice(index, 1);
	}
	return index;
}
